import React, { useContext, useState, useEffect, useRef } from "react";
import ChangePasswordModal from "./ChangePasswordModal";
import DeleteAccountModal from "./DeleteAccountModal";
import { ModalContext } from "../home/Header";
import { useAuthStore } from "../../redux/features/authSlice";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

export default function DropdownMenu({ closeDrawer = () => {} }) {
  const [isOpen, setIsOpen] = useState(false);
  let { loginInfo,removeLoginInfo } = useAuthStore();
  const dropdownRef = useRef(null); // Ref for the dropdown
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();

  const {
    isChangePasswordModalOpen,
    setIsChangePasswordModalOpen,
    setIsDeleteModalOpen,
  } = useContext(ModalContext);

  const openMenu = () => {
    setIsOpen((prev) => !prev);
  };

  const openChangePasswordModal = () => {
    closeDrawer();
    setIsOpen(false);
    setIsChangePasswordModalOpen(true);
  };

  const openDeleteAccountModal = () => {
    closeDrawer();
    setIsOpen(false);
    setIsDeleteModalOpen(true);
  };

  const logoutFun=()=>{
    removeLoginInfo()
    // Example: redirect to home after logout, respecting language
    navigate(i18n.language === 'en' ? '/en' : '/');
  }

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="relative inline-block text-left" ref={dropdownRef}>
      {/* Button to open menu */}
      <button
        onClick={openMenu}
        className="p-2 border border-[#E2E8F0] text-red-600 rounded-full"
      >
        <div className="w-[24px] h-[22px]">
          <i className="fi fi-ss-user"></i>
        </div>
      </button>

      {/* Menu items */}
      {isOpen && (
        <div className="absolute z-10 right-0 mt-2 w-[250px] bg-white rounded-lg shadow-md shadow-[0px 7px 27.8px 0px #00000026]">
          <div className="text-center p-2">
            <button className="p-6 border text-center relative border-[#E2E8F0] text-red-600 rounded-full">
              <div className="w-[30px] h-[30px]">
                <i className="fi fi-ss-user text-3xl"></i>
              </div>

              <div className="p-1 absolute right-0 bottom-0 rounded-full bg-secondary">
                <div className="w-[18px] h-[18px]">
                  <i className="fi fi-sr-pencil text-xs text-white"></i>
                </div>
              </div>
            </button>

            <h6 className="text-lg font-semibold mt-2 text-primary-text">
              {loginInfo?.user?.fullname}
            </h6>

            <p className="text-base font-medium text-[#5D5D5D] truncate mt-1">
              {loginInfo?.user?.email}
            </p>
          </div>

          <ul className="py-2 px-4">
            <li
              onClick={openChangePasswordModal}
              className="px-4 py-2 text-[#5D5D5D] text-center font-medium hover:bg-gray-100 cursor-pointer"
            >
              {t("dropdown_change_password")}
            </li>
            <hr className="border-[#C0C0C0] w-full" />
            <li
              onClick={openDeleteAccountModal}
              className="px-4 py-2 text-[#5D5D5D] text-center font-medium hover:bg-gray-100 cursor-pointer"
            >
              {t("dropdown_delete_account")}
            </li>
            <hr className="border-[#C0C0C0] w-full" />
            <li className="px-4 py-2 text-red-600 text-center font-medium hover:bg-gray-100 cursor-pointer" onClick={logoutFun}>
              {t("dropdown_logout")}
            </li>
          </ul>
        </div>
      )}
    </div>
  );
}
